import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductionForm from './ProductionForm/ProductionForm';
import ProductionFilters from './ProductionFilters/ProductionFilters';
import * as actions from '../../../../store/actions/index';
import { getMonthLong } from './../../../Helpers/DateFormat';
import Spinner from './../../../UI/Spinner/Spinner';

const MontlyProductions = () => {
  const productions = useSelector(state => state.productions.montlyProductions);

  const loading = useSelector(state => state.productions.loading);

  const date = new Date();
  const [year, setYear] = useState(date.getFullYear());
  const [firstProdEl, setFirstProdEl] = useState();
  const [realTotals, setRealTotals] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (productions) {
      let firstProdKey = Object.keys(productions.table_data)[0];
      setFirstProdEl(productions.table_data[firstProdKey]);
    }
  }, [productions]);

  useEffect(() => {
    if (firstProdEl && productions) {
      const fixTotals = [];
      firstProdEl.forEach(element => {
        const totalExist = productions.totals.find(el => el.id === element.impianto_id);
        if (totalExist) {
          fixTotals.push(totalExist);
        }
      });
      setRealTotals(fixTotals);
    }
  }, [firstProdEl, productions]);

  useEffect(() => {
    dispatch(actions.getMontlyProductions(date.getFullYear()));
  }, []);

  const getProductionsHandler = ev => {
    ev.preventDefault();
    dispatch(actions.getMontlyProductions(year));
  };

  const uploadProductionsHandler = (ev, date, csv) => {
    ev.preventDefault();
    dispatch(actions.newMontlyProduction(date, csv, year));
  };

  return (
    <>
      <ProductionFilters
        year={year}
        changeYear={year => setYear(year)}
        click={(ev, year) => getProductionsHandler(ev, year)}
      />
      <div className='container mt-4'>
        <h4 className='mb-3'>Tabella produzioni mensili (kWh):</h4>

        <ProductionForm />

        {loading ? (
          <div className='prodLoading'>
            <Spinner type='static' />
          </div>
        ) : (
          <div className='tec-table-container my-5'>
            <div className='tec-table-wrapper'>
              <table className='tec-table'>
                <thead className='thead-light'>
                  <tr>
                    <th>Mese</th>
                    {firstProdEl?.map((el, index) => (
                      <th key={index}>{el.impianto_nome}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {productions
                    ? Object.keys(productions.table_data).map((el, index) => (
                        <tr key={index}>
                          <th>{getMonthLong(el)}</th>
                          {productions.table_data[el].map((el, index) => {
                            if (el.valore === '-1.00') {
                              return <td key={index}>-</td>;
                            } else {
                              return <td key={index}>{Math.floor(el.valore)}</td>;
                            }
                          })}
                        </tr>
                      ))
                    : null}
                  <tr>
                    <th>Totale</th>
                    {realTotals.map((el, index) => (
                      <td key={index}>{Math.floor(el.produzione_totale)}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MontlyProductions;
